<template>
  <div>
    <v-card width="100%" v-if="current">
      <v-card-title>Dados do registro</v-card-title>
      <v-card-text>
        <v-form>
          <div class="row">
            <div class="col-md-12 col-sm-1">
              <v-text-field
                label="Nome"
                v-model="current.name"
                outlined
                dense
                disabled
              ></v-text-field>
            </div>
            <div class="col-md-12 col-sm-1">
              <v-text-field
                label="Responsável"
                v-model="current.responsable"
                outlined
                dense
                disabled
              ></v-text-field>
            </div>
          </div>
          <div class="row" v-if="!$auth.isSubuser()">
            <div class="col-md-3 col-sm-1">
              <v-text-field
                label="Compels ID"
                v-model="current.compelsId"
                outlined
                dense
                disabled
              ></v-text-field>
            </div>
            <div class="col-md-3 col-sm-1">
              <v-text-field
                label="Compels Código"
                v-model="current.compelsCode"
                outlined
                dense
                disabled
              ></v-text-field>
            </div>
            <div class="col-md-3 col-sm-1">
              <v-text-field
                label="Compels CEP"
                v-model="current.compelsZipcode"
                outlined
                dense
                disabled
              ></v-text-field>
            </div>
            <div class="col-md-3 col-sm-1">
              <v-text-field
                label="Compels Cidade"
                v-model="current.compelsCity"
                outlined
                dense
                disabled
              ></v-text-field>
            </div>
          </div>

          <v-tabs v-model="tab" grow class="mt-2">
            <v-tab key="dy"> Cadastro </v-tab>
            <v-tab key="ot"> Endereço </v-tab>
          </v-tabs>

          <v-tabs-items v-model="tab">
            <v-tab-item key="dy">
              <v-card flat>
                <v-card-text>
                  <div class="row">
                    <div class="col-md-3 col-sm-1">
                      <v-text-field
                        label="CPF/CNPJ"
                        v-model="current.register"
                        outlined
                        dense
                        disabled
                      ></v-text-field>
                    </div>
                    <div class="col-md-3 col-sm-1">
                      <v-text-field
                        label="RG/IE"
                        v-model="current.register2"
                        outlined
                        dense
                        disabled
                      ></v-text-field>
                    </div>
                    <div class="col-md-3 col-sm-1">
                      <v-text-field
                        label="CFOP"
                        v-model="current.cfop"
                        outlined
                        dense
                        disabled
                      ></v-text-field>
                    </div>
                    <div class="col-md-3 col-sm-1">
                      <v-text-field
                        v-model="computedBirth"
                        label="Nasc./Fund."
                        outlined
                        dense
                        disabled
                      ></v-text-field>
                    </div>
                    <div class="col-md-4 col-sm-1">
                      <v-text-field
                        label="Telefone"
                        v-model="current.telephone"
                        outlined
                        dense
                        disabled
                      ></v-text-field>
                    </div>
                    <div class="col-md-4 col-sm-1">
                      <v-text-field
                        label="Celular"
                        v-model="current.cellphone"
                        outlined
                        dense
                        disabled
                      ></v-text-field>
                    </div>
                    <div class="col-md-4 col-sm-1">
                      <v-text-field
                        label="Fax"
                        v-model="current.fax"
                        outlined
                        dense
                        disabled
                      ></v-text-field>
                    </div>
                    <div class="col-md-6 col-sm-1">
                      <v-text-field
                        label="Email"
                        v-model="current.email"
                        outlined
                        dense
                        disabled
                      ></v-text-field>
                    </div>
                    <div class="col-md-6 col-sm-1">
                      <v-text-field
                        label="Site"
                        v-model="current.site"
                        outlined
                        dense
                        disabled
                      ></v-text-field>
                    </div>
                    <div class="col-md-6 col-sm-1">
                      <v-textarea
                        label="Emails adicionais"
                        v-model="current.emailExtra"
                        outlined
                        dense
                        disabled
                      ></v-textarea>
                    </div>
                    <div class="col-md-6 col-sm-1">
                      <v-textarea
                        label="Observações"
                        v-model="current.obs"
                        outlined
                        dense
                        disabled
                      ></v-textarea>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item key="ot">
              <v-card flat>
                <v-card-text>
                  <div class="row">
                    <div class="col-md-6 col-sm-1">
                      <v-text-field
                        label="Logradouro"
                        v-model="current.address"
                        outlined
                        dense
                        disabled
                      ></v-text-field>
                    </div>
                    <div class="col-md-2 col-sm-1">
                      <v-text-field
                        label="Número"
                        v-model="current.addressNumber"
                        outlined
                        dense
                        disabled
                      ></v-text-field>
                    </div>
                    <div class="col-md-2 col-sm-1">
                      <v-text-field
                        label="Complemento"
                        v-model="current.addressExtra"
                        outlined
                        dense
                        disabled
                      ></v-text-field>
                    </div>
                    <div class="col-md-2 col-sm-1">
                      <v-text-field
                        label="Bairro"
                        v-model="current.addressNeighborhood"
                        outlined
                        dense
                        disabled
                      ></v-text-field>
                    </div>
                    <div class="col-md-3 col-sm-1">
                      <v-text-field
                        label="Cidade"
                        v-model="current.city"
                        outlined
                        dense
                        disabled
                      ></v-text-field>
                    </div>
                    <div class="col-md-3 col-sm-1">
                      <v-text-field
                        label="Estado"
                        v-model="current.province"
                        outlined
                        dense
                        disabled
                      ></v-text-field>
                    </div>
                    <div class="col-md-3 col-sm-1">
                      <v-text-field
                        label="País"
                        v-model="current.country"
                        outlined
                        dense
                        disabled
                      ></v-text-field>
                    </div>
                    <div class="col-md-3 col-sm-1">
                      <v-text-field
                        label="CEP"
                        v-model="current.zipcode"
                        outlined
                        dense
                        disabled
                      ></v-text-field>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <div>
          <v-btn color="primary" class="ma-2" @click="dialogNames()">
            Alterar Nomes
          </v-btn>
          <v-btn color="primary" class="ma-2" @click="dialogDocs()">
            Alterar Documentos
          </v-btn>
          <v-btn color="primary" class="ma-2" @click="dialogPhones()">
            Alterar Telefones
          </v-btn>
          <v-btn color="primary" class="ma-2" @click="dialogEmails()">
            Alterar Emails
          </v-btn>
          <v-btn color="primary" class="ma-2" @click="dialogObs()">
            Alterar Observações
          </v-btn>
          <v-btn color="primary" class="ma-2" @click="dialogAddress()">
            Alterar Endereço
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>

    <v-dialog v-model="dialog_loading" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Por favor aguarde
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_names" max-width="500px">
      <v-card>
        <v-card-title>Alterar Nomes</v-card-title>
        <v-card-text>
          <div class="col-md-12 col-sm-1">
            <v-text-field
              label="Nome"
              v-model="changed.name"
              outlined
              dense
            ></v-text-field>
            <v-text-field
              label="Responsável"
              v-model="changed.responsable"
              outlined
              dense
            ></v-text-field>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="success" @click="putNames()">Salvar</v-btn>
          <v-btn color="default" @click="dialog_names = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_docs" max-width="500px">
      <v-card>
        <v-card-title>Alterar Documentos</v-card-title>
        <v-card-text>
          <div class="col-md-12 col-sm-1">
            <v-text-field
              label="CPF/CNPJ"
              v-model="changed.register"
              outlined
              dense
            ></v-text-field>
          </div>
          <div class="col-md-12 col-sm-1">
            <v-text-field
              label="RG/IE"
              v-model="changed.register2"
              outlined
              dense
            ></v-text-field>
          </div>
          <div class="col-md-12 col-sm-1">
            <v-text-field
              label="CFOP"
              v-model="changed.cfop"
              outlined
              dense
            ></v-text-field>
          </div>
          <div class="col-md-12 col-sm-1">
            <v-menu
              v-model="menu_birth"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="birthText"
                  label="Nasc./Fund."
                  placeholder="dd/mm/aaaa"
                  :error-messages="birthError"
                  @blur="birthDigitada()"
                  outlined
                  dense
                >
                  <template v-slot:append>
                    <v-icon v-bind="attrs" v-on="on">mdi-calendar</v-icon>
                  </template>
                </v-text-field>
              </template>
              <v-date-picker
                v-model="changed.birth"
                @input="birthAlterada()"
                locale="pt-br"
              ></v-date-picker>
            </v-menu>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="success" @click="putDocs()">Salvar</v-btn>
          <v-btn color="default" @click="dialog_docs = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_phones" max-width="500px">
      <v-card>
        <v-card-title>Alterar Telefones</v-card-title>
        <v-card-text>
          <div class="col-md-12 col-sm-1">
            <v-text-field
              label="Telefone"
              v-model="changed.telephone"
              outlined
              dense
            ></v-text-field>
          </div>
          <div class="col-md-12 col-sm-1">
            <v-text-field
              label="Celular"
              v-model="changed.cellphone"
              outlined
              dense
            ></v-text-field>
          </div>
          <div class="col-md-12 col-sm-1">
            <v-text-field
              label="Fax"
              v-model="changed.fax"
              outlined
              dense
            ></v-text-field>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="success" @click="putPhones()">Salvar</v-btn>
          <v-btn color="default" @click="dialog_phones = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_emails" max-width="500px">
      <v-card>
        <v-card-title>Alterar Emails</v-card-title>
        <v-card-text>
          <div class="col-md-12 col-sm-1">
            <v-text-field
              label="Email"
              v-model="changed.email"
              outlined
              dense
            ></v-text-field>
          </div>
          <div class="col-md-12 col-sm-1">
            <v-textarea
              label="Emails adicionais"
              v-model="changed.emailExtra"
              outlined
              dense
            ></v-textarea>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="success" @click="putEmails()">Salvar</v-btn>
          <v-btn color="default" @click="dialog_emails = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_obs" max-width="500px">
      <v-card>
        <v-card-title>Alterar Observações</v-card-title>
        <v-card-text>
          <div class="col-md-12 col-sm-1">
            <v-text-field
              label="Site"
              v-model="changed.site"
              outlined
              dense
            ></v-text-field>
          </div>
          <div class="col-md-12 col-sm-1">
            <v-textarea
              label="Observações"
              v-model="changed.obs"
              outlined
              dense
            ></v-textarea>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="success" @click="putObs()">Salvar</v-btn>
          <v-btn color="default" @click="dialog_obs = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_address" max-width="600px">
      <v-card>
        <v-card-title>Alterar Endereço</v-card-title>
        <v-card-text>
          <div class="col-md-12 col-sm-1">
            <v-text-field label="Logradouro" v-model="changed.address" outlined dense ></v-text-field>
          </div>
          <div class="col-md-12 col-sm-1">
            <v-text-field label="Número" v-model="changed.addressNumber" outlined dense ></v-text-field>
          </div>
          <div class="col-md-12 col-sm-1">
            <v-text-field label="Complemento" v-model="changed.addressExtra" outlined dense ></v-text-field>
          </div>
          <div class="col-md-12 col-sm-1">
            <v-text-field label="Bairro" v-model="changed.addressNeighborhood" outlined dense ></v-text-field>
          </div>
          <div class="col-md-12 col-sm-1">
            <v-text-field label="Cidade" v-model="changed.city" outlined dense ></v-text-field>
          </div>
          <div class="col-md-12 col-sm-1">
            <v-text-field label="Estado" v-model="changed.province" outlined dense ></v-text-field>
          </div>
          <div class="col-md-12 col-sm-1">
            <v-text-field label="Pais" v-model="changed.country" outlined dense ></v-text-field>
          </div>
          <div class="col-md-12 col-sm-1">
            <v-text-field label="CEP" v-model="changed.zipcode" outlined dense ></v-text-field>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="success" @click="putAddress()">Salvar</v-btn>
          <v-btn color="default" @click="dialog_address = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import api from "../../api/index.js";
export default {
  data: () => ({
    current: null,
    changed: { 
      birth: null
    },
    tab: null,
    menu_birth: false,
    birthText: "",
    birthError: "",
    dialog_loading: false,
    dialog_names: false,
    dialog_docs: false,
    dialog_phones: false,
    dialog_emails: false,
    dialog_obs: false,
    dialog_address: false
  }),
  created: function () {
    this.load();
  },
  methods: {
    load: function () {
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .get("/client/" + this.$route.params.id, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.current = response.data;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao recuperar registro!");
          console.log(error);
        });
    },
    formatDate: function (date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate: function (text) {
      // aceita "dd/mm/aaaa" ou só os dígitos "ddmmaaaa"
      const digits = text.replace(/\D/g, "");
      if (digits.length !== 8) return null;
      const day = digits.substr(0, 2);
      const month = digits.substr(2, 2);
      const year = digits.substr(4, 4);
      const d = new Date(year, month - 1, day);
      if (
        d.getFullYear() != year ||
        d.getMonth() + 1 != month ||
        d.getDate() != day
      )
        return null;
      return `${year}-${month}-${day}`;
    },
    birthAlterada: function () {
      this.menu_birth = false;
    },
    birthDigitada: function () {
      const text = (this.birthText || "").trim();
      if (!text) {
        this.birthError = "";
        this.changed.birth = null;
        return;
      }
      const iso = this.parseDate(text);
      if (!iso) {
        this.birthError = "Data inválida (dd/mm/aaaa)";
        return;
      }
      this.birthError = "";
      this.changed.birth = iso;
      this.birthText = this.formatDate(iso);
    },
    dialogNames: function () {
      this.changed.name = this.current.name;
      this.changed.responsable = this.current.responsable;
      this.dialog_names = true;
    },
    putNames: function () {
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .put("/client/names/" + this.$route.params.id, this.changed, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.dialog_names = false;
          alert("Nomes alterados com sucesso!");
          me.current = response.data;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao alterar nomes!");
          console.log(error);
        });
    },
    dialogDocs: function () {
      this.changed.register = this.current.register;
      this.changed.register2 = this.current.register2;
      this.changed.cfop = this.current.cfop;
      this.changed.birth = this.current.birth;
      this.birthText = this.formatDate(this.current.birth) || "";
      this.birthError = "";
      this.dialog_docs = true;
    },
    putDocs: function () {
      var me = this;
      var token = localStorage.getItem("token");
      if (me.birthError) {
        alert("Corrija a data de nascimento/fundação!");
        return;
      }
      me.dialog_loading = true;
      api
        .put("/client/docs/" + this.$route.params.id, this.changed, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.dialog_docs = false;
          alert("Documentos alterados com sucesso!");
          me.current = response.data;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao alterar documentos!");
          console.log(error);
        });
    },
    dialogPhones: function () {
      this.changed.telephone = this.current.telephone;
      this.changed.cellphone = this.current.cellphone;
      this.changed.fax = this.current.fax;
      this.dialog_phones = true;
    },
    putPhones: function () {
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .put("/client/phones/" + this.$route.params.id, this.changed, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.dialog_phones = false;
          alert("Telefones alterados com sucesso!");
          me.current = response.data;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao alterar telefones!");
          console.log(error);
        });
    },
    dialogEmails: function () {
      this.changed.email = this.current.email;
      this.changed.emailExtra = this.current.emailExtra;
      this.dialog_emails = true;
    },
    putEmails: function () {
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .put("/client/emails/" + this.$route.params.id, this.changed, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.dialog_emails = false;
          alert("Emails alterados com sucesso!");
          me.current = response.data;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao alterar emails!");
          console.log(error);
        });
    },
    dialogObs: function () {
      this.changed.site = this.current.site;
      this.changed.obs = this.current.obs;
      this.dialog_obs = true;
    },
    putObs: function () {
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .put("/client/obs/" + this.$route.params.id, this.changed, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.dialog_obs = false;
          alert("Observações alterados com sucesso!");
          me.current = response.data;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao alterar observações!");
          console.log(error);
        });
    },
    dialogAddress: function () {
      this.changed.address = this.current.address;
      this.changed.addressNumber = this.current.addressNumber;
      this.changed.addressExtra = this.current.addressExtra;
      this.changed.addressNeighborhood = this.current.addressNeighborhood;
      this.changed.city = this.current.city;
      this.changed.province = this.current.province;
      this.changed.country = this.current.country;
      this.changed.zipcode = this.current.zipcode;
      this.dialog_address = true;
    },
    putAddress: function () {
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .put("/client/address/" + this.$route.params.id, this.changed, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.dialog_address = false;
          alert("Endereço alterado com sucesso!");
          me.current = response.data;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao alterar endereço!");
          console.log(error);
        });
    }
  },
  computed: {
    computedBirth() {
      return this.formatDate(this.current.birth);
    },
  },
  watch: {
    "changed.birth": function (value) {
      this.birthText = this.formatDate(value) || "";
      this.birthError = "";
    },
  },
};
</script>